import { invert, mapValues } from 'remeda'
import { Chain } from 'viem'
import {
  arbitrum,
  avalanche,
  base,
  baseSepolia,
  gnosis,
  mainnet,
  optimism,
  sepolia,
  unichain,
  worldchain,
} from 'viem/chains'

import { assert } from '../assert/assert.js'

export const allSparkDomains = [
  'mainnet',
  'base',
  'gnosis',
  'arbitrum',
  'optimism',
  'worldchain',
  'unichain',
  'avalanche',
  'sepolia',
  'baseSepolia',
] as const
export type SparkDomain = (typeof allSparkDomains)[number]

export const domainToChain = {
  mainnet,
  base,
  gnosis,
  arbitrum,
  worldchain,
  optimism,
  unichain,
  avalanche,
  sepolia,
  baseSepolia,
} as const satisfies Record<SparkDomain, Chain>
export type SparkChainId = (typeof domainToChain)[SparkDomain]['id']

export const domainToChainId = mapValues(domainToChain, (chain) => chain.id) as MapDomainToChainToId<
  typeof domainToChain
>

export const chainIdToDomain = invert(domainToChainId)

/**
 * Does extra runtime check. Useful when dealing with arbitrary chain ids.
 */
export function getUnsafeChainIdToDomain(_chainId: number | string): SparkDomain {
  const chainId: number =
    typeof _chainId === 'number'
      ? _chainId
      : (() => {
          const parsed = Number.parseInt(_chainId)

          assert(!Number.isNaN(parsed), `Domain "${_chainId}" can't be parsed as number`)

          return parsed
        })()

  if (chainId in chainIdToDomain) {
    return (chainIdToDomain as any)[chainId]
  }
  throw new Error(`ChainId=${chainId} not supported!`)
}

type MapDomainToChainToId<T> = T extends { [K in keyof T]: Chain } ? { [K in keyof T]: T[K]['id'] } : never
